import React from 'react';
import { Button, Alert } from 'antd';
import { WarningOutlined, SettingOutlined } from '@ant-design/icons';
import { SetupPromptProps } from '@/types/TTextingPlatform';

const SetupPrompt: React.FC<SetupPromptProps> = ({
	message,
	showButton = false,
	buttonText = 'Setup',
	onButtonClick,
	themeColor = '#007bff',
}) => {
	return (
		<div className="w-full min-h-[400px] flex items-center justify-center bg-white rounded-lg shadow-lg">
			<div className="max-w-md mx-auto text-center p-8">
				<div className="mb-6">
					<WarningOutlined className="text-6xl text-orange-500 mb-4" />
				</div>

				<Alert
					message="Setup Required"
					description={message}
					type="warning"
					showIcon
					className="mb-6 text-left"
				/>

				{showButton && onButtonClick && (
					<Button
						type="primary"
						size="large"
						icon={<SettingOutlined />}
						onClick={onButtonClick}
						style={{
							backgroundColor: themeColor,
							borderColor: themeColor,
						}}
						className="flex items-center gap-2 mx-auto"
					>
						{buttonText}
					</Button>
				)}
			</div>
		</div>
	);
};

export default SetupPrompt;
